import { createStore } from "vuex";
import axios from 'axios'
 
export default createStore({
  state: {
    status: '',
    user: {},
    isLoading:false,
    val:'',
    toggle:true,
    dotsLoading:false,
    dbPriority:[],
    dbFrequency:[],
    dbProcessCriticality:[],
    labelsStatus:'',
    tenantsInfo:[],
    dbBussiness:[],
    dbOverAllImpact:[],
    dbFinancial:[],
    dbLegal:[],
    dbSeverity:[],
    dbLikelihood:[],
    dbOperations:[],
  },
  mutations: {
    auth_request(state) {
      state.status = 'loading'
    },
    auth_success(state, user) {
      state.status = 'success'
      state.user = user
    },
    auth_error(state) {
      state.status = 'error'
    },
    logout(state) {
      state.status = ''
    },
    tenants_info(state,tenantsData){
        state.labelsStatus = 'success'
        state.tenantsInfo = tenantsData
    },
    labels_request(state){
            state.labelsStatus = 'loading'
    },
    labels_success(state,labelsData){
       state.labelsStatus = 'success'
        labelsData.map((item:any)=>{
            switch(item.entityId){
                case 20413:
                    state.dbPriority = item.values;
                    break;
                case 20415:
                    state.dbProcessCriticality = item.values;
                    break;
                case 20417:
                    state.dbFrequency = item.values;
                    break
                case 20408:
                    state.dbBussiness = item.values;
                    break;
                case 20416:
                    state.dbOverAllImpact = item.values;
                    break;
                case 20410:
                    state.dbFinancial = item.values;
                    break;
                case 20411:
                    state.dbLegal = item.values;
                    break;
                case 20412:
                    state.dbSeverity = item.values;
                    break;
                case 20405:
                    state.dbLikelihood = item.values;
                    break;
                case 20406:
                    state.dbOperations = item.values;
                    break;
            }  
        })
    },
    setDotsLoading(state, newValue) {
      state.dotsLoading = newValue;
  },
  },
  actions: {
    getUserInfo({ commit }) {
      commit('auth_request')
      return new Promise((resolve, reject) => {
        axios({
          url: `${process.env.VUE_APP_AUTH_API}/userInfo/get`,
          method: 'GET',
          withCredentials: true,
          headers: {
            Authorization: 'Bearer ' + localStorage.getItem('AUTH_ID')
          }
        })
        .then(resp => {
          const user = resp.data[0];
          // user.currentRole = user.roles.find((role:any) => { return role.appId == 10002 }).roleId
          commit('auth_success', user)
          this.dispatch('getTenantsInfo')
          this.dispatch('getLabelsInfo')
          resolve(resp)
        })
        .catch(err => {
            commit('auth_error');
            reject(err);
            localStorage.removeItem('AUTH_ID');
            // window.location.href = window.location.origin+'/monitor/onboarding'
            // window.location.href = 'http://localhost:8080'
            window.location.href = `${process.env.VUE_APP_AUTH_UI}/?returnTo=${process.env.VUE_APP_PLANNER_UI}`
          })
      })
    },
    getTenantsInfo({commit}){
            return new Promise((resolve, reject) => {
            axios({
                url: `${process.env.VUE_APP_AUTH_API}/tenants/getAll`,
                method: 'GET',
                headers:{
                    Authorization : 'Bearer ' + localStorage.getItem('AUTH_ID')
                }
            })
            .then(resp => {
                commit('tenants_info', resp.data);
                resolve(resp)
            })
            .catch(err => {
                console.log('error in tenants', err)
                reject(err);
            })
        })
    },
    getLabelsInfo({commit}){
        commit('labels_request')
 
        return  new Promise((resolve, reject) => {
            axios({
            url: `${process.env.VUE_APP_ORG_API}/api/org/labels/getall`,
            method: 'GET',
            headers: {
                Authorization: 'Bearer ' + localStorage.getItem('AUTH_ID')
              }
        })
        .then(resp => {
                commit('labels_success', resp.data);
                resolve(resp)
            })
        .catch(err => {
                commit('labels_error')
                reject(err);
            })
        })
    },
    logout({ commit }) {
      return new Promise<void>((resolve) => {
        commit('logout');
        resolve();
      })
    },
    selectedRoute(context, payload) {
      context.state.val=payload
     },
     selectedToggle(context, payload) {
      context.state.toggle=payload
     },
     updateDotsLoading({ commit }, newValue) {
      commit('setDotsLoading', newValue);
    }
  },
  getters: {
    authStatus: state => state.status,
    userInfo: state => state.user,
    loading:state=>state.isLoading,
    val:state=>state.val,
    toggle:state=>state.toggle,
    dotsLoading:state=>state.dotsLoading,
    dbPriority:state => state.dbPriority,
    dbProcessCriticality:state => state.dbProcessCriticality,
    dbFrequency:state => state.dbFrequency,
    tenantsInfo:state=>state.tenantsInfo,
    dbBussiness:state => state.dbBussiness,
    dbFinancial:state => state.dbFinancial,
    dbLegal:state => state.dbLegal,
    dbLikelihood:state => state.dbLikelihood,
    dbOperations:state => state.dbOperations,
    dbSeverity:state => state.dbSeverity,
    dbOverAllImpact:state => state.dbOverAllImpact,
  }
});